import CodebookValueNotFoundError from '../CodebookValueNotFoundError'
import { $t } from '../../composables/i18n'

export enum BedAssignmentId {
  ON_BED = 1,
  WITHOUT_BED = 3,
}

export class BedAssignment {
  private constructor(
    public readonly id: BedAssignmentId,
    public readonly name: () => string,
  ) {}

  static readonly ON_BED = new BedAssignment(BedAssignmentId.ON_BED, () => $t('On bed'))
  static readonly WITHOUT_BED = new BedAssignment(BedAssignmentId.WITHOUT_BED, () =>
    $t('Without bed'),
  )

  static getById = (id: BedAssignmentId): BedAssignment => {
    const value = BedAssignment.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(BedAssignment.name, id)
    }

    return value
  }

  static all = (): BedAssignment[] => {
    return [BedAssignment.ON_BED, BedAssignment.WITHOUT_BED]
  }
}
